import {
  BOT_LIST,
  BOT_DETAIL,
  GET_SUBSCRIPTION,
  GET_BALANCE,
  BOT_PROFIT,
  GET_PAIRS,
  GET_INDICATORS,
  BOT_RENT_LIST,
  RENT_BOT_DETAIL,
  GET_ACCOUNT_PAIR,
  PRICE_ALERT_PAIR,
  SELECT_EXCHANGE,
  SET_DAISY_CHAIN_BOTS,
} from "./types";
import { CHANGE_EXCHANGE, CHANGE_PAIR, CHANGE_RENT_PAIR }  from "../actions/create-bot-type";
import { subscription } from "../mocks/subscriptions-mock";

import {
  botDetail,
  balanceUrl,
  botListUrl,
  updateBotStatusUrl,
  deleteBotUrl,
  botProfitUrl,
  pairListUrl,
  indicatorsUrl,
  templateRentUrl,
  rentDetailUrl,
  thumbsUpUrl,
  pairBalanceUrl,
  forceOrderUrl,
  updateBotUrl,
  exitConditionsUrl,
  resetExitConditionsUrl,
  daisyChainUrl,
  bulkUpdateBotsUrl,
} from "./const";

import network from "./network";

export const getBots = (exchangeId,pageSize,pageNum=1,status,orderBy,sort,searchBotName) => (dispatch, getState) => {
  let params = {
    exchange_id: exchangeId,
    page_size: pageSize,
    page: pageNum,
    status: status,
    sort_direction: orderBy?orderBy:"",
    sort_by: sort?sort:"",
    bot_name: searchBotName?searchBotName:"",
  };
  if(!status || status=="all"){
    delete params.status
  }

  network.get(botListUrl, params, dispatch, getState).then((res) => {
    dispatch({
      type: BOT_LIST,
      payload: {
        bots:res.data.bots.data,
        totalBots:res.data.bots.total,
        startItem:pageNum?res.data.bots.from:1,
        pageNum:pageNum?pageNum:1,
        status:status
      }
    });
    
  });
};
export const getRentalBots = (exchangeId,pageSize,pageNum,status,orderBy,sort,searchBotName) => (dispatch, getState) => {
  let params = {
    exchange_id: exchangeId,
    page_size: pageSize,
    page: pageNum,
    status: 'renting',
  };
  if(orderBy){
    params.sort_direction = orderBy
  }
  if(searchBotName){
    params.search = searchBotName
  }

  network.get(templateRentUrl, params, dispatch, getState).then((res) => {
    dispatch({
      type: BOT_RENT_LIST,
      payload: {
        rents:res.data.rents.data,
        totalBots:res.data.rents.total,
        startItem:res.data.rents.from,
        pageNum:pageNum
      }
    });
    
  });
};
export const deleteBot = (id,exchangeId,pageSize,pageNum,selectedTab,orderBy,sort) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    network
      .post(
        deleteBotUrl,
        {
          id,
          force: 1,
        },
        dispatch,
        getState
      )
      .then((res) => {
        const { code, message } = res.data;
        if (code == 200) {
          dispatch(getBots(exchangeId,pageSize,pageNum,selectedTab,orderBy,sort));
          resolve();
        } else {
          reject(message);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const forceEnterOrder = (botId,orderType) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    network
      .post(
        updateBotUrl+botId+forceOrderUrl,
        {
          order_name: orderType,
        },
        dispatch,
        getState
      )
      .then((res) => {
        const { code, message } = res.data;
        if (code == 200) {
          resolve();
        } else {
          reject(message);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const modifyBotExitConditions = (botId, profit, stopLoss) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    network
      .post(
        updateBotUrl+botId+exitConditionsUrl,
        {
          profit,
          stop_loss: stopLoss,
        },
        dispatch,
        getState
      )
      .then((res) => {
        const { code, message, bot } = res.data;
        if (code == 200) {
          if (bot) {
            dispatch({
              type: BOT_DETAIL,
              payload: bot,
            });
          }
          resolve(res.data);
        } else {
          reject(message);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const resetBotExitConditions = (botId) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    network
      .post(
        updateBotUrl+botId+resetExitConditionsUrl,
        {},
        dispatch,
        getState
      )
      .then((res) => {
        const { code, message, bot } = res.data;
        if (code == 200) {
          if (bot) {
            dispatch({
              type: BOT_DETAIL,
              payload: bot,
            });
          }
          resolve(res.data);
        } else {
          reject(message);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const activeBot = (id, status,exchangeId,pageSize,pageNum,selectedTab,orderBy,sort,reactivationAction = null) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const body = {
      id,
      status,
      client_platform: "web",
    };
    if (reactivationAction) {
      body.reactivation_action = reactivationAction;
    }
    network
      .post(
        updateBotStatusUrl,
        body,
        dispatch,
        getState
      )
      .then((res) => {
        const { code, message, requires_reactivation_action } = res.data;
        if (code === 200) {
          dispatch(getBots(exchangeId,pageSize,pageNum,selectedTab,orderBy,sort));
          resolve(res.data);
        } else if (requires_reactivation_action) {
          resolve(res.data);
        } else {
          reject(message);
        }
      })
      .catch((err) => {
        reject(String(err));
      });
  });
};

export const getSubscription = () => (dispatch) => {
  setTimeout(() => {
    dispatch({
      type: GET_SUBSCRIPTION,
      payload: subscription,
    });
  }, 1000);
};

export const getBotDetail = (id) => (dispatch, getState) => {
  dispatch({
    type: BOT_DETAIL,
    payload: {},
  });
  return new Promise((resolve, reject) => {
    network
      .get(
        botDetail,
        {
          id,
        },
        dispatch,
        getState
      )
      .then((res) => {
        const { code, message, bot } = res.data;
        if (code === 200) {
          dispatch({
            type: BOT_DETAIL,
            payload: bot,
          });
          resolve(bot);
        } else {
          reject(message);
        }
      })
      .catch((err) => {
        reject(String(err));
      });
  });
};

export const getExchangePairs = (exchangeId,reload) => (dispatch, getState) => {
  network
    .get(pairListUrl, { exchange_id: exchangeId,default:1,symbol:"AAAAA" }, dispatch, getState)
    .then((res) => {
      const { exchange } = res.data;
       dispatch({
          type: CHANGE_EXCHANGE,
          payload: exchange
        });
        dispatch({
          type: SELECT_EXCHANGE,
          payload: exchange
        });
     
    });
};
export const loadExchangePairs = (exchangeId,reload) => (dispatch, getState) => {
  return new Promise((resolve,reject)=>{
    network
    .get(pairListUrl, { exchange_id: exchangeId,default:1,symbol:"AAAAA" }, dispatch, getState)
    .then((res) => {
      const { exchange } = res.data;
      dispatch({
          type: CHANGE_EXCHANGE,
          payload: exchange
        });
        dispatch({
          type: SELECT_EXCHANGE,
          payload: exchange
        });
      resolve();
    });
  })
  
};

const sortPairs = async (pairs) => {
  return pairs.sort((a, b) => {
    if (a.pair_id < b.pair_id) return -1;
    if (a.pair_id > b.pair_id) return 1;
    return 0;
  });
};

export const searchExchangePair = (exchangeId,symbol,rentId=false) => (dispatch, getState) => {
  let params = {
    exchange_id: exchangeId,
    symbol: symbol,
  };
  if(rentId){
    params.rent_id = rentId;
  }
  return new Promise((resolve,reject)=>{
      network
      .get(pairListUrl, params, dispatch, getState)
      .then((res) => {
        const { usd,exchange,code } = res.data;
        resolve(usd)
      })
  })  
};
  
  

export const getAgenticPairs = (exchangeId, rentId) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
            .get(pairListUrl, { exchange_id: exchangeId, rent_id: rentId }, dispatch, getState)
            .then((res) => {
                const { usd } = res.data;
                resolve(usd);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getIndicators = () => (dispatch, getState) => {
  const CACHE_KEY = "indicators_cache";
  const cachedData = localStorage.getItem(CACHE_KEY);
  if (cachedData) {
    const { indicators } = JSON.parse(cachedData);
    dispatch({
      type: GET_INDICATORS,
      payload: {
        indicators,
      },
    });
    return;
  }
  network.get(indicatorsUrl, {}, dispatch, getState).then((res) => {
    const { indicators } = res.data;
    localStorage.setItem(CACHE_KEY, JSON.stringify({ indicators }));
    dispatch({
      type: GET_INDICATORS,
      payload: {
        indicators,
      },
    });
  });
};
export const getDaisyChainBots = (exchangeId) => (dispatch, getState) => {
  network.get(daisyChainUrl, {exchange_id: exchangeId}, dispatch, getState).then((res) => {
    const { bots } = res.data;
    dispatch({
      type: SET_DAISY_CHAIN_BOTS,
      payload: bots
    });
  });
};

export const getBalance = (exchangeId) => (dispatch, getState) => {
  network
    .get(
      balanceUrl,
      {
        exchange_id: exchangeId,
      },
      dispatch,
      getState
    )
    .then((res) => {
      const { code, exchange } = res.data;
      if (code == 200) {
        dispatch({
          type: GET_BALANCE,
          payload: res.data.exchange.user_balances,
        });
      } else {
        dispatch({
          type: GET_BALANCE,
          payload: 0,
        });
      }
    });
};
export const getPairBalance = (exchangeId,pairId,account) => (dispatch, getState) => {
  network
    .get(
      pairBalanceUrl,
      {
        exchange_id: exchangeId,
        pair_id: pairId,
        account: account,
      },
      dispatch,
      getState
    )
    .then((res) => {
      const { code } = res.data;
      if (code == 200) {
        dispatch({
          type: GET_ACCOUNT_PAIR,
          payload: res.data,
        });
      } else {
        dispatch({
          type: GET_ACCOUNT_PAIR,
          payload: {},
        });
      }
    });
};

export const getRentBotDetail = (id) => (dispatch, getState) => {
  dispatch({
    type: RENT_BOT_DETAIL,
    payload: {},
  });
  return new Promise((resolve, reject) => {
    network
      .get(
        rentDetailUrl+id,
        {},
        dispatch,
        getState
      )
      .then((res) => {
        const { code, message, rent } = res.data;
        if (code === 200) {
          dispatch({
            type: RENT_BOT_DETAIL,
            payload: rent,
          });
          resolve(rent);
        } else {
          reject(message);
        }
      })
      .catch((err) => {
        reject(String(err));
      });
  });
};
export const botFeedback = (value,templateId,exchangeId,pageSize,pageNum) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    network
      .post(
        thumbsUpUrl,
        {
          template_id:templateId,
          value:value==0?1:0,
        },
        dispatch,
        getState
      )
      .then((res) => {
        const { code, message } = res.data;
        if (code === 200) {
          dispatch(getRentalBots(exchangeId,pageSize,pageNum));
          resolve();
        } else {
          reject(message);
        }
      })
      .catch((err) => {
        reject(String(err));
      });
  });
};

export const bulkUpdateBots = (botIds, action, exchangeId, pageSize, pageNum, selectedTab, orderBy, sort) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        network
            .post(
                bulkUpdateBotsUrl,
                {
                    bot_ids: botIds.toString(),
                    action: action
                },
                dispatch,
                getState
            )
            .then((res) => {
                const { code, message } = res.data;
                if (code === 200) {
                    dispatch(getBots(exchangeId, pageSize, pageNum, selectedTab, orderBy, sort));
                    resolve({ message });
                } else {
                    reject(message);
                }
            })
            .catch((err) => {
                reject(String(err));
            });
    });
};
